import React from 'react';
import PropTypes from 'prop-types';
// components
import ResWrapper from '../components/ResWrapper';
import QuickReplies from '../components/QuickReplies';
// data
import { sampleText, sampleCarousel } from '../store/jsonData';
// ui
import Icon from '@material-ui/core/Icon';

const UiContents = ({ obj, callbackFromParent }) => {
    if (!obj || !obj.template || !obj.template.outputs) {
        alert('잘못된 응답 타입입니다.');
        return null;
    }

    // response wrapper 에서 받은 데이타
    const parentCallback = (dataFromChild) => {
        //아이템 컴포넌트 변경 시 부모한테 전달
        callbackFromParent(dataFromChild);
    };

    // 응답 추가
    let newData = {};
    const onClickAddData = (e) => {
        if (obj.template.outputs.length < 3) {
            let type = e.target.name;
            if (type === 'simpleImage') {
                newData = {
                    simpleImage: {
                        imageUrl: '',
                        altText: '',
                    },
                };
            } else if (type === 'simpleText') {
                newData = {
                    simpleText: {
                        text: '',
                    },
                };
            } else {
                newData = {
                    carousel: {
                        type: 'basicCard',
                        items: [
                            {
                                title: '',
                                description: '',
                            },
                        ],
                    },
                };
            }

            let resultOutputs = obj.template.outputs.concat(newData);

            let resultObj = {
                version: '2.0',
                template: {
                    outputs: resultOutputs,
                    quickReplies: obj.template.quickReplies,
                },
            };

            //부모한테 전달
            callbackFromParent(resultObj);
        } else {
            alert('응답은 3개까지 가능합니다.');
        }
    };

    // 순서 변경 및 제거
    const itemWrapperCallback = (index, action) => {
        // copy
        let outputsObj = obj.template.outputs;

        // 순서 변경
        if (action) {
            // 해당 아이템 뽑음
            const moveItem = outputsObj.filter(
                (num) => num === outputsObj[index]
            );
            //
            if (action === 'up' && index > 0) {
                outputsObj.splice(index, 1);
                outputsObj.splice(index - 1, 0, ...moveItem);
            } else if (action === 'down' && index < outputsObj.length - 1) {
                outputsObj.splice(index, 1);
                outputsObj.splice(index + 1, 0, ...moveItem);
            } else if (action === 'del') {
                outputsObj = obj.template.outputs.filter(
                    (num) => num !== outputsObj[index]
                );
            } else {
                return alert('끝');
            }
            // 아니면 삭제 (인데 언디파인드로 받고 있는데 정확히 받을까여??!!!)
        } else {
            console.log('no action');
        }

        //  변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: outputsObj,
                quickReplies: obj.template.quickReplies,
            },
        };

        // 부모한테 전달
        callbackFromParent(resultObj);
    };

    // 응답 리스트
    let resList = obj.template.outputs.map(function (outputsEl, index) {
        return (
            <ResWrapper
                key={index}
                obj={obj}
                outputsEl={outputsEl}
                index={index}
                callbackFromParent={parentCallback}
                itemWrapperCallback={itemWrapperCallback}
            />
        );
    });

    // 바로 연결 추가
    const onClickAddQuick = (e) => {
        // 바로 연결 없을 경우
        if (!obj.template.quickReplies) {
            let quickRepliesData = [
                {
                    action: 'message',
                    label: '버튼 설정',
                    messageText: '',
                },
            ];

            let resultObj = {
                version: '2.0',
                template: {
                    outputs: obj.template.outputs,
                    quickReplies: quickRepliesData,
                },
            };

            //부모한테 전달
            callbackFromParent(resultObj);
        }
    };

    // 샘플
    const onClickSample = (e) => {
        //alert('챗봇 예제를 불러올 경우 현재 작업중인 내용이 모두 사라집니다.');
        const result = window.confirm(
            '챗봇 예제를 불러올 경우 현재 작업중인 내용이 모두 사라집니다.'
        );
        if (result) {
            const type = e.target.dataset.type;
            if (type === 'text') {
                callbackFromParent(JSON.parse(JSON.stringify(sampleText)));
            } else if (type === 'card') {
                callbackFromParent(JSON.parse(JSON.stringify(sampleCarousel)));
            } else {
                return;
            }
        } else {
            return;
        }
    };

    return (
        <div className="left-content">
            {/* 상단 */}
            <header>
                {/* 로고, 응답 갯수*/}
                <div className="header-top">
                    <h1>JSON2Bot</h1>
                    <span>
                        봇 응답 추가<span>{obj.template.outputs.length}</span> /
                        3
                    </span>
                    <div className="header-help">
                        <a
                            href="https://www.notion.so/dreamys/Json2Bot-a44554bf381a45da956b86a62f2be3e3"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Icon>help_outline</Icon>도움말
                        </a>
                    </div>
                </div>
                {/* 응답 추가 버튼 */}
                <div className="content-add-btn-wrap">
                    <button onClick={onClickAddData} name="simpleText">
                        <Icon>insert_comment</Icon>
                        <em>텍스트</em>
                    </button>
                    <button onClick={onClickAddData} name="simpleImage">
                        <Icon>insert_photo</Icon>
                        <em>이미지</em>
                    </button>
                    <button onClick={onClickAddData} name="carousel">
                        <Icon>credit_card</Icon>
                        <em>카드</em>
                    </button>
                    <button onClick={onClickAddQuick} name="quickReplies">
                        <Icon>swap_calls</Icon>
                        <em>바로연결</em>
                    </button>
                </div>
                <div className="content-sample-btn-wrap">
                    <h5>SAMPLE</h5>
                    <div>
                        <button onClick={onClickSample} data-type="text">
                            텍스트+이미지
                        </button>
                        <button onClick={onClickSample} data-type="card">
                            카드(케로셀)
                        </button>
                    </div>
                </div>
            </header>
            {/* 하단 */}
            <main>
                {resList}
                {obj.template.quickReplies && (
                    <QuickReplies
                        obj={obj}
                        quickRepliesList={obj.template.quickReplies}
                        callbackFromParent={parentCallback}
                        isQuickReplies={true}
                    />
                )}
            </main>
        </div>
    );
};

UiContents.propTypes = {
    obj: PropTypes.object,
    callbackFromParent: PropTypes.func,
};

UiContents.defaultProps = {
    // bla: 'test',
};

export default UiContents;
